import {observer} from "mobx-react"
import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"
import {Table} from "semantic-ui-react"
import Price from "components/Price/Price"
import _ from "lodash"
import shop from "shop/shop"
import { Link } from "react-router-dom"
import Responsive                                                from "react-responsive"

@observer
export default class ProductTableReadOnly extends Component {
	static propTypes = {
		list    : PropTypes.object,
		cart    : PropTypes.object,
		onChange: PropTypes.func,
		products: PropTypes.array,
		minimal : PropTypes.bool
	}

	constructor() {
		super()
	}

	render() {
		let {list, cart, products, onChange, minimal, showTax} = this.props
		let positions = list || products
		if ( list ) positions = list.products
		let rows = _.map( positions, ( product, index ) => {
			return (
				<ProductRow showTax={showTax} minimal={minimal} key={index} index={index} onChange={onChange} list={list} cart={cart} product={product} />
			)
		} )
		return (<Fragment>
			<Responsive minWidth={790}>
			<Table>
				<colgroup>
					<col width="5%" />
					{shop.session && shop.session.shopuser && shop.session.shopuser.guest && <col width="80%" />}
					{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <col width="40%" />}
					{shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<col width="" />}
					<col width="10%" />
					<col width="10%" />
					{shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<col width="10%" />}
				</colgroup>
				<thead>
				<tr>
					<th>&nbsp;</th>
					<th>{translate("Artikel")}</th>
					{!minimal && shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <th>{translate("Preis/VE")}</th>}
					<th>{translate( "VE" )}</th>
					<th>{translate( "Menge" )}</th>
					{showTax && <th>{translate( "Steuer" )}</th>}
					{shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<th className="tr">
						<div className="tr">{translate( "Summe" )}</div>
					</th>}
				</tr>
				</thead>
				<tbody>
				{rows}
				</tbody>
			</Table>
				</Responsive>
				<Responsive maxWidth={789}>
					<table className="mobileRespTable" >
					<colgroup>
						<col width="10%"/>
						<col width="90%"/>
						</colgroup>
					<tbody>
					{rows}
					</tbody>
					</table>
				</Responsive>
		</Fragment>

		)
	}
}

const ProductRow = ( {product, minimal, showTax} ) => {
	console.log("ProductRow",product)
	  if (shop.cart && shop.cart.data && Array.isArray(shop.cart.data.products) && shop.cart.data.extras && shop.cart.data.extras.couponCode !== "" ) {
		const cartProduct = shop.cart.data.products.find(p => p.article_id === product.map_id);
		console.log("cartProduct",cartProduct, shop.cart.data, product)
		if (cartProduct) {
		  product.price = cartProduct.price;
		  if (cartProduct.extras && cartProduct.extras.brutto !== undefined) {
			if (!product.pinfos) product.pinfos = {};
			product.pinfos.brutto = cartProduct.extras.brutto;
		  }
		}
	  }
	return (<Fragment>
			<Responsive minWidth={790}>
			<tr>
			      <td>
				<Link to={`/product/${product.map_id}`}>
					<img
						className="db center"
						height="34"
						src={product.img_src_small}
						alt=""/>
				</Link>
			</td>
			<td>
				<strong>{product.article_nr}</strong>
				<div><span className="product-title"><span className="nowrap">{product.title}</span></span></div>
			</td>
			{!minimal && shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <td>
				{product.pinfos && product.pinfos.brutto && product.pinfos.brutto !== "" && <div className=" pr2"><span className="strike black-60"><Price>{product.pinfos.brutto}</Price></span><br/><span className="red fw6 pb2 tr"><Price>{product.price}</Price></span></div>}
				{product.pinfos && (!product.pinfos.brutto || product.pinfos.brutto === "") &&  <div className=" pr2"><Price>{product.price}</Price></div>}
				{Object.keys(product.pinfos).length === 0 &&  <div className=" pr2"><Price>{product.price}</Price></div>}
        <div className="flex flex-row">
          {/*product.pinfos.gc_rabatt && <a title={translate( "Coupon-Rabatt" )} className="labelNeu1">&nbsp;&nbsp;{translate("Coupon:")} {product.pinfos.gc_rabatt} %&nbsp;&nbsp;</a>*/}
          {product.isSale && product.pinfos.sale_percent && <a className="labelNeu1">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>}
        </div>
      </td>}
			<td>
				<div className={"nowrap"}>{product.quantities && product.quantities[0] && product.quantities[0].des ? product.quantities[0].des : translate("Stück")}</div>
			</td>
			<td>
				<div className={"nowrap"}>{product.count} </div>
			</td>
			{showTax && shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <td>
				<div><Price>{product.price * product.count * product.unit_multi * product.taxRate}</Price></div>
				<div className={"black-60"}>{product.taxRate * 100} %</div>
			</td>}
			{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <td>
        <div className="tr">
        {product.pinfos && product.pinfos.brutto && product.pinfos.brutto !== "" && <div><span className="strike black-60"><Price>{product.pinfos.brutto * product.count * product.unit_multi}</Price></span></div>}
        {product.pinfos && product.pinfos.brutto && product.pinfos.brutto !== "" && <div><span className="red fw6 pb2 tr"><Price>{product.price * product.count * product.unit_multi}</Price></span></div>}
		{product.pinfos && (!product.pinfos.brutto || product.pinfos.brutto === "") &&  <div><Price>{product.price * product.count * product.unit_multi}</Price></div>}
        {Object.keys(product.pinfos).length === 0 && <div><Price>{product.price * product.count * product.unit_multi}</Price></div>}
          <div>{product.unit_multi * product.count} {product.quantities && product.quantities[0] && product.quantities[0].des ? product.quantities[0].des : translate("Stück")} </div>
        </div>
      </td>}
		</tr>
				</Responsive>
		    <Responsive maxWidth={789}>
    <tr className={` ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
    <td className="tl pt2 pb2">
				<Link to={`/product/${product.map_id}`}>
					<img style={{maxWidth: "70px",maxHeight: "70px", minWidth: "70px",minHeight: "70px", overflow: "hidden",objectFit: "contain"}}
						className="pl2 db left"
						src={product.img_src_small}
						alt=""/>
				</Link>
			</td>
        <td  className=" pr2  pt2 bb b--black-20 tr f6 v-center">
                  <Link to={`/product/${product.map_id}`}>
          <strong>{product.article_nr}</strong> &nbsp;
          <span className="product-title">{product.title}</span>
        </Link></td>
        <td>&nbsp;</td>
      </tr>
      <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "Lieferbar:" )} </td>
        <td  className="pr2 bb b--black-20 tr f5 fw7"><span className="f6 tr">{product.getNotice( "tiny" )}</span></td>
      </tr>
      {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "Preis/VE:" )} </td>
        <td  className="pr2 bb b--black-20 tr f5 fw7">
      {product.pinfos && product.pinfos.brutto && product.pinfos.brutto !== "" && <div className="tr pr2"><span className="strike black-60"><Price>{product.pinfos.brutto}</Price></span><br/><span className="red fw6 pb2 tr"><Price>{product.price}</Price></span></div>}
      {product.pinfos && (!product.pinfos.brutto || product.pinfos.brutto === "") && <div className="tr pr2"><Price>{product.price}</Price></div>}
      {Object.keys(product.pinfos).length === 0 &&  <div className="tr pr2"><Price>{product.price}</Price></div>}
        <div className="flex flex-row">
          {/*product.pinfos.gc_rabatt && <div title={translate( "Coupon-Rabatt" )} className="mr1 pb2"><Label size="tiny" className={"giftcardPercent"} color="red"><span className="ttu">-{product.pinfos.gc_rabatt} %</span></Label></div>*/}
          {/*product.pinfos.gc_rabatt && <a title={translate( "Coupon-Rabatt" )} className="labelNeu1">&nbsp;&nbsp;{translate("Coupon:")} {product.pinfos.gc_rabatt} %&nbsp;&nbsp;</a>}
          {/*product.isSale && <div title={translate( "Ihr Kundenrabatt" )} className="pb2"><Label size="tiny" className={"salePercent"} color="red">-{product.salePercent}</Label></div>*/}
          {/*product.isSale && <a className="labelNeu">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>*/}
          {product.isSale && product.pinfos.sale_percent && <a className="labelNeu1">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>}
        </div></td>
      </tr>}
      <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "VE:" )} </td>
        <td  className="pr2 bb b--black-20 tr f5 fw7">
        <div>{product.quantities && product.quantities[0] && product.quantities[0].des ? product.quantities[0].des : translate("Stück")} </div>
        </td>
      </tr>
	  <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "Menge:" )} </td>
        <td  className="pr2 bb b--black-20 tr f5 fw7">
        <div>{product.count}</div>
        </td>
      </tr>
      {/*shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<tr className={` ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="pl2  fw7 f5">{translate( "Menge:" )} </td>
        <td  className="pr2 bb b--black-20 tr f5 fw7">
        <div className="tr">
        {product.pinfos && product.pinfos.brutto && <div><span className="strike black-60"><Price>{product.pinfos.brutto * product.count * product.unit_multi}</Price></span></div>}
        {product.pinfos && product.pinfos.brutto && <div><span className="red fw6 pb2 tr"><Price>{product.price * product.count * product.unit_multi}</Price></span></div>}
        {Object.keys(product.pinfos).length === 0 && <div><Price>{product.price * product.count * product.unit_multi}</Price></div>}
          <div>{product.unit_multi * product.count} {product.quantities && product.quantities[0] && product.quantities[0].des ? product.quantities[0].des : translate("Stück")}</div>
        </div>
        </td>
      </tr>*/}
	  {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <tr className={` ProductRowDefReturnMobileRight step ${(product.count-1) > 0 && "inCart"}`}>
		<td className="pl2  fw7 f5">{translate( "Summe:" )} </td>
	  <td className="tr b">
        {product.pinfos && product.pinfos.brutto && product.pinfos.brutto !== "" && <div><span className="strike black-60"><Price>{product.pinfos.brutto * product.count * product.unit_multi}</Price></span></div>}
        {product.pinfos && product.pinfos.brutto && product.pinfos.brutto !== "" && <div><span className="red fw6 pb2 tr"><Price>{product.price * product.count * product.unit_multi}</Price></span></div>}
		{product.pinfos && (!product.pinfos.brutto || product.pinfos.brutto === "") &&  <div><Price>{product.price * product.count * product.unit_multi}</Price></div>}
        {Object.keys(product.pinfos).length === 0 && <div><Price>{product.price * product.count * product.unit_multi}</Price></div>}
          <div>{"/ "}{product.unit_multi * product.count} {product.quantities && product.quantities[0] && product.quantities[0].des ? product.quantities[0].des : translate("Stück")} </div>
        
      </td>
	  </tr>}
      {/*<tr className={`  ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="bb fw7 f5 ProductRowDefReturnMobileLeft">
        {translate( "UVP:" )}
        </td >
      <td className="tr b--black-20 bb ProductRowDefReturnMobileRight">
        <Price>{product.price * (product.count-1)}</Price>
        </td>
      </tr>*/}
    </Responsive>
    </Fragment>
		
	)
}

ProductRow.propTypes = {
	index   : PropTypes.any,
	list    : PropTypes.object,
	cart    : PropTypes.object,
	onChange: PropTypes.func,
	product : PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/theme/hvz/components/Product/ProductTableReadOnly.js